import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline';
import type { FaqItem } from './faqData';

type FaqDisclosureListProps = {
  items: FaqItem[];
};

export const FaqDisclosureList = ({ items }: FaqDisclosureListProps) => {
  return (
    <dl className="divide-y divide-grey-800 text-left">
      {items.map((faq) => (
        <Disclosure key={faq.question} as="div" className="py-6 first:pt-0 last:pb-0">
          <dt>
            <DisclosureButton className="group flex w-full items-start justify-between gap-6 text-left text-grey-100">
              <span className="text-[1rem] font-semibold leading-7">{faq.question}</span>
              <span className="flex h-7 shrink-0 items-center text-primary-50">
                <PlusIcon aria-hidden="true" className="size-6 group-data-open:hidden" />
                <MinusIcon aria-hidden="true" className="size-6 group-not-data-open:hidden" />
              </span>
            </DisclosureButton>
          </dt>
          <DisclosurePanel as="dd" className="mt-3 pr-10">
            <p className="text-[1rem] leading-7 text-grey-300">{faq.answer}</p>
          </DisclosurePanel>
        </Disclosure>
      ))}
    </dl>
  );
};
